import { twMerge } from 'tailwind-merge';

type RadioButtonProps<T> = {
  options: {
    label: string;
    value: T;
  }[];
  value?: T;
  onChange?: (value: T) => void;
  disabled?: boolean;
  outerClassName?: string;
  innerClassName?: string;
  error?: string;
  name?: string;
};

export const RadioButton = <T,>({
  options,
  value,
  onChange,
  disabled,
  outerClassName,
  innerClassName,
  error,
  name,
}: RadioButtonProps<T>) => {
  // Fully controlled by `value`. Previously this component kept its own
  // `selected` state seeded once from `value`, which meant programmatic
  // updates from react-hook-form `setValue` (e.g. UAT #17 — the age-16
  // age-redirect on QQ1 syncing the policyholder's gender to the child's)
  // never re-rendered the selection.
  return (
    <div
      className={twMerge('flex w-full', outerClassName)}
      data-error-anchor={name}
    >
      {options.map(({ label, value: optionValue }) => (
        <button
          key={label}
          type="button"
          className={twMerge(
            'w-full border border-[#B1B1B1] py-2',
            innerClassName,
            value === optionValue
              ? 'bg-[#333333] text-white'
              : 'bg-white text-[#333333]',
            error && 'border-error',
          )}
          disabled={disabled}
          onClick={() => {
            onChange?.(optionValue);
          }}
        >
          {label}
        </button>
      ))}
    </div>
  );
};
